import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DocumentLinkCards from './DocumentLinkCards';
import { parseMessageDocumentLinks } from '../utils/documentLinks';

interface RichMessageContentProps {
  content: string;
  markdownComponents: Record<string, React.ComponentType<any>>;
}

const RichMessageContent: React.FC<RichMessageContentProps> = ({
  content,
  markdownComponents,
}) => {
  const parsed = useMemo(() => parseMessageDocumentLinks(content), [content]);

  return (
    <div className="rich-message-content">
      {parsed.body && (
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
          {parsed.body}
        </ReactMarkdown>
      )}
      <DocumentLinkCards heading={parsed.documentsHeading} documents={parsed.documents} />
      {parsed.disclaimer && (
        <div className="document-link-disclaimer">{parsed.disclaimer}</div>
      )}
    </div>
  );
};

export default RichMessageContent;
